<template>
    <div>
        <div class="overlay" @click="close"></div>
        <div id="combo-selector" v-bind:style="{ top: ( style.top ) + 'px', left: style.left + 'px', width: style.width + 'px', borderColor: style.backgroundColor, color: style.color }">
            <div class="option" @click="check( value.id, $event )" v-for="( value, key ) in values" :key="key" :class="{ selected: value.id == current }">{{ getI18n( value.name ) }}</div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import i18n from '@/i18n'

    export default {
        data(){
            return {
                style: { top: 0, left: 0 },
                values: [],
                current: "",
                callBackSave: function(){},
                callBackClose: function(){}
            }
        },

        methods: {
            check( id, e ){
                e.preventDefault();
                e.stopPropagation();

                if( this.current != id ){
                    this.callBackSave( id );
                    this.callBackClose( this );
                }
                else {
                    this.callBackClose( this );
                }
            },

            close(){
                this.callBackClose( this )
            },

            getI18n( label ){
                return i18n.t( label );
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #000;
        z-index: $z-overlay;
        opacity: 0.3;
    }
    #combo-selector {
        position: absolute;
        height: auto;
        border: 0px solid #ccc;
        background-color: #FFF;
        z-index: $z-popups-default;
        border-radius: 5px;

        .option {
            text-align: left;
            padding: 6px 10px;
            font-size: 14px;
            cursor: pointer;

            &:not( :first-child ) {
                border-top: 1px solid #ddd;
                border-color: inherit;
            }
        }
    }
</style>


